import { HttpParams } from '@angular/common/http';
import { ParamsPaginacion } from '../objetos/simple-response';

/** Agrega `pagina`, `limite`, `busqueda` y el orden (`orden`/`direccion`) al query cuando se pide paginado real. */
export const aplicarPaginacion = (
  params: HttpParams,
  paginacion?: ParamsPaginacion | null,
): HttpParams => {
  if (!paginacion) return params;
  if (paginacion.pagina) params = params.set('pagina', paginacion.pagina);
  if (paginacion.limite) params = params.set('limite', paginacion.limite);
  if (paginacion.busqueda) params = params.set('busqueda', paginacion.busqueda);
  if (paginacion.orden && paginacion.direccion) {
    params = params.set('orden', paginacion.orden).set('direccion', paginacion.direccion);
  }
  return params;
};
